import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class PlotSeedReleaseBreakdownViewSliderModelService {
  public plotSeedReleaseBreakdownViewSlider: BehaviorSubject<boolean>;
  public plotSeedReleaseBreakdownViewSidenav: MatSidenav;
  private activeSliderValue: string;
  plotSeedReleaseBreakdownViewSliderCloseRqt: Subject<boolean>;
  plotSeedReleaseBreakdownViewModelData: BehaviorSubject<any>;
  plotSeedReleaseData: BehaviorSubject<any> = new BehaviorSubject(EMPTY);
  public viewEditText: string;
  public releaseOrderItem: any;
  public branchPlant: string;
  public releaseItemsLots: any;

  constructor() {
    this.plotSeedReleaseBreakdownViewSlider = new BehaviorSubject(false);
    this.plotSeedReleaseBreakdownViewModelData = new BehaviorSubject(EMPTY);
    this.plotSeedReleaseBreakdownViewSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'plotSeedReleaseBreakdownView') {
      this.plotSeedReleaseBreakdownViewSlider.next(true);
      this.plotSeedReleaseBreakdownViewModelData.next(EMPTY);
      this.plotSeedReleaseBreakdownViewSidenav.toggle();
    }
  }

  public setplotSeedReleaseBreakdownViewSideNav(plotSeedReleaseBreakdownViewSideNavObj: MatSidenav) {
    this.plotSeedReleaseBreakdownViewSidenav = plotSeedReleaseBreakdownViewSideNavObj;
  }

  public plotSeedReleaseBreakdownViewClose() {
    this.plotSeedReleaseBreakdownViewModelData.next(EMPTY);
    this.plotSeedReleaseBreakdownViewSlider.next(false);
    this.plotSeedReleaseBreakdownViewSidenav.close();
  }

  public setplotSeedReleaseBreakdownViewData<T>(obj: T) {
    this.plotSeedReleaseData.next(obj);
  }

  public setData<T>(obj: T) {
    this.plotSeedReleaseBreakdownViewModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.plotSeedReleaseBreakdownViewModelData.next(obj);
  }
}
